import { render, staticRenderFns } from "./WhyCalendarEvents.vue?vue&type=template&id=38742d4e&"
import script from "./WhyCalendarEvents.vue?vue&type=script&lang=js&"
export * from "./WhyCalendarEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports